import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const TermsOfService = () => {
  return (
    <div className="min-h-screen gradient-secondary">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="flex items-center mb-8">
          <Link 
            to="/" 
            className="p-2 glass rounded-full hover:bg-white/10 transition-smooth mr-4"
          >
            <ArrowLeft className="w-5 h-5 text-white" />
          </Link>
          <h1 className="text-3xl font-bold gradient-text">Termini di Servizio</h1>
        </div>

        <Card className="glass border-white/20 mb-6">
          <CardHeader>
            <CardTitle className="text-white">Data di ultima modifica: 1 Settembre 2025</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6 text-white/90">
            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">1. Accettazione dei Termini</h2>
              <p className="leading-relaxed">
                Accedendo e utilizzando AstroPet ("Servizio"), accetti di essere vincolato dai presenti Termini di Servizio. 
                Se non accetti questi termini, non utilizzare il nostro servizio.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">2. Descrizione del Servizio</h2>
              <p className="leading-relaxed mb-4">
                AstroPet è una piattaforma social network dedicata agli amanti degli animali domestici che offre:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Creazione e gestione di profili per animali domestici</li>
                <li>Condivisione di contenuti multimediali</li>
                <li>Sistema di messaggistica e comunicazione</li>
                <li>Servizi di adozione e rehoming</li>
                <li>Mappa interattiva per servizi pet-friendly</li>
                <li>Sistema SOS per emergenze</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">3. Requisiti di Registrazione</h2>
              <p className="leading-relaxed mb-4">
                Per utilizzare AstroPet devi:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Avere almeno 13 anni di età</li>
                <li>Fornire informazioni accurate e veritiere</li>
                <li>Mantenere la sicurezza del tuo account</li>
                <li>Non creare account multipli o falsi</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">4. Uso Accettabile</h2>
              <p className="leading-relaxed mb-4">Ti impegni a NON utilizzare il servizio per:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Pubblicare contenuti illegali, dannosi o offensivi</li>
                <li>Molestare, intimidire o minacciare altri utenti</li>
                <li>Violare diritti di proprietà intellettuale</li>
                <li>Diffondere spam o contenuti commerciali non autorizzati</li>
                <li>Impersonare altre persone o entità</li>
                <li>Interferire con la sicurezza o il funzionamento del servizio</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">5. Contenuti e Proprietà Intellettuale</h2>
              <p className="leading-relaxed mb-4">
                Mantieni la proprietà dei contenuti che pubblichi. Tuttavia, concedi ad AstroPet una licenza 
                non esclusiva per utilizzare, distribuire e visualizzare tali contenuti sulla piattaforma.
              </p>
              <p className="leading-relaxed">
                Rispetta i diritti di proprietà intellettuale di terzi. Non pubblicare contenuti protetti da copyright 
                senza autorizzazione.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">6. Privacy e Protezione Dati</h2>
              <p className="leading-relaxed">
                Il trattamento dei tuoi dati personali è disciplinato dalla nostra Privacy Policy, 
                che costituisce parte integrante di questi Termini e rispetta il Regolamento Generale 
                sulla Protezione dei Dati (GDPR) UE 2016/679.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">7. Servizi di Adozione</h2>
              <p className="leading-relaxed mb-4">
                Per i servizi di adozione e rehoming:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>AstroPet funge solo da piattaforma di collegamento</li>
                <li>Non garantiamo l'idoneità degli animali o degli adottanti</li>
                <li>Ogni transazione è di responsabilità delle parti coinvolte</li>
                <li>Raccomandiamo visite veterinarie e controlli appropriati</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">8. Limitazione di Responsabilità</h2>
              <p className="leading-relaxed">
                AstroPet viene fornito "così com'è". Non garantiamo che il servizio sia sempre disponibile, 
                sicuro o privo di errori. La nostra responsabilità è limitata al massimo consentito dalla legge.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">9. Sospensione e Terminazione</h2>
              <p className="leading-relaxed">
                Possiamo sospendere o terminare il tuo account in caso di violazione di questi termini. 
                Puoi cancellare il tuo account in qualsiasi momento dalle impostazioni.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">10. Modifiche ai Termini</h2>
              <p className="leading-relaxed">
                Ci riserviamo il diritto di modificare questi termini. Le modifiche saranno comunicate 
                attraverso la piattaforma e entreranno in vigore 30 giorni dopo la pubblicazione.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">11. Legge Applicabile</h2>
              <p className="leading-relaxed">
                Questi termini sono disciplinati dalla legge italiana. Per controversie, 
                sarà competente il Foro di [Città], Italia.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold gradient-text mb-4">12. Contatti</h2>
              <p className="leading-relaxed">
                Per domande sui Termini di Servizio, contattaci all'indirizzo: legal@astropet.com
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfService;